export const navLinks = [
  { label: "事件时间线", href: "#timeline" },
  { label: "全盘点合集", href: "#events" },
  { label: "人气热议榜", href: "#ranking" },
  { label: "图文档案馆", href: "#gallery" },
  { label: "常见疑问", href: "#faq" },
];

export const hotKeywords = [
  "灵灵黑料事件汇总",
  "时间线大合集",
  "关键节点复盘",
  "全盘点火速版",
  "前后经过对照",
];

export const heroStats = [
  { value: "48", label: "已梳理关键节点" },
  { value: "260+", label: "收录相关动态" },
  { value: "9", label: "个阶段完整归档" },
  { value: "每日", label: "持续补充更新" },
];

export const quickEntries = [
  {
    id: "entry-timeline",
    title: "时间线速览",
    desc: "从最早的那条动态开始，一条线看完整个过程。",
    icon: "ri-route-line",
    meta: "约 3 分钟读完",
    href: "#timeline",
    tone: "primary",
  },
  {
    id: "entry-collection",
    title: "全盘点合集",
    desc: "把散落各处的零碎信息，按阶段重新拼回完整拼图。",
    icon: "ri-stack-line",
    meta: "共 9 期归档",
    href: "#events",
    tone: "secondary",
  },
  {
    id: "entry-archive",
    title: "图文打包下载",
    desc: "整理好的时间线图与节点长图，一次带走慢慢看。",
    icon: "ri-download-2-line",
    meta: "含 6 张长图",
    href: "#gallery",
    tone: "accent",
  },
  {
    id: "entry-subscribe",
    title: "更新提醒",
    desc: "有新节点补充时，第一时间收到整理好的摘要。",
    icon: "ri-notification-3-line",
    meta: "邮箱即可",
    href: "#subscribe",
    tone: "primary",
  },
];

export const timelineNodes = [
  {
    id: "t1",
    date: "08.02",
    phase: "第一阶段 · 起点",
    title: "话题最初的样子",
    desc: "一条并不起眼的日常动态被截取传播，早期信息量极少，多数人只是路过，没有意识到这会是整件事的开端。",
    level: "normal",
  },
  {
    id: "t2",
    date: "08.05",
    phase: "第一阶段 · 起点",
    title: "二次搬运开始出现",
    desc: "不同平台的搬运号陆续跟进，配上了各自的解读，讨论从一个小圈子外溢到更大范围，版本开始明显分叉。",
    level: "normal",
  },
  {
    id: "t3",
    date: "08.09",
    phase: "第二阶段 · 发酵",
    title: "讨论量第一次明显上扬",
    desc: "相关话题的讨论进入加速期，同一件事出现了互相对不上的说法，围观者开始主动去寻找更早的来源。",
    level: "normal",
  },
  {
    id: "t4",
    date: "08.11",
    phase: "第三阶段 · 引爆",
    title: "关键节点：公开回应",
    desc: "当事一方首次给出公开说明，内容被反复截图引用，也成为后续所有讨论绕不开的参照点，热度在这一天达到阶段高点。",
    level: "key",
  },
  {
    id: "t5",
    date: "08.14",
    phase: "第三阶段 · 引爆",
    title: "合作方的动作被整理",
    desc: "网友把品牌、节目组、平台方在几天内的公开动作逐条罗列出来，形成了另一条容易被忽略的观察线。",
    level: "normal",
  },
  {
    id: "t6",
    date: "08.18",
    phase: "第四阶段 · 反复",
    title: "转折点：早期线索重新浮现",
    desc: "被忽略的早期素材被重新翻出，与后来的说法形成对照，讨论方向出现明显偏移，围观者的判断开始分化。",
    level: "turning",
  },
  {
    id: "t7",
    date: "08.22",
    phase: "第四阶段 · 反复",
    title: "补充说明与二次澄清",
    desc: "针对新的质疑，出现了补充说明，但对部分细节的表述依旧留白，这也让话题热度出现了第二次小高峰。",
    level: "normal",
  },
  {
    id: "t8",
    date: "08.28",
    phase: "第五阶段 · 沉淀",
    title: "热度回落，进入复盘期",
    desc: "讨论逐渐从情绪转向梳理，越来越多内容变成「按时间线讲清楚」的复盘帖，也正因如此才有了这一页汇总。",
    level: "normal",
  },
];

export const eventCards = [
  {
    id: "ev1",
    title: "起底：这件事最早到底是怎么开始的",
    summary:
      "把最早那几条几乎没人注意的动态按顺序摆出来，你会发现整件事的起点其实比大多数人以为的更平淡，也更值得细看。",
    tag: "起点梳理",
    category: "起底",
    date: "08.02 — 08.05",
    readTime: "6 分钟",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20illustration%20of%20a%20single%20spotlight%20falling%20on%20a%20folded%20newspaper%2C%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=900&height=1000&seq=lh-card-01&orientation=portrait",
  },
  {
    id: "ev2",
    title: "发酵：二次传播是怎么把它推上去的",
    summary: "梳理搬运与解读的先后顺序，看清哪一波流量真正改变了话题的规模。",
    tag: "传播路径",
    category: "发酵",
    date: "08.05 — 08.09",
    readTime: "5 分钟",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20rising%20wave%20shapes%20and%20ascending%20bars%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=460&seq=lh-card-02&orientation=landscape",
  },
  {
    id: "ev3",
    title: "回应：那段公开说明里的每一句话",
    summary: "把公开回应逐句拆开，看哪些问题被正面回答，哪些只是绕过。",
    tag: "原文对照",
    category: "回应",
    date: "08.11",
    readTime: "4 分钟",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20microphone%20and%20speech%20bubble%20silhouette%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=460&seq=lh-card-03&orientation=landscape",
  },
  {
    id: "ev4",
    title: "反转：被忽略的早期线索重新出现",
    summary: "为什么几天之后风向会变？关键就在几段早于回应的素材。",
    tag: "节点复盘",
    category: "反转",
    date: "08.18",
    readTime: "7 分钟",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20mirrored%20shapes%20and%20reversed%20arrows%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=460&seq=lh-card-04&orientation=landscape",
  },
  {
    id: "ev5",
    title: "联动：合作方的动作时间表",
    summary: "品牌与平台的每一步公开动作，拼起来是另一条常被忽略的线。",
    tag: "外围动作",
    category: "回应",
    date: "08.14 — 08.20",
    readTime: "5 分钟",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20linked%20tag%20shapes%20and%20connected%20nodes%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=460&seq=lh-card-05&orientation=landscape",
  },
  {
    id: "ev6",
    title: "留白：还有哪几个细节没被说清",
    summary: "汇总各方说法里互相对不上的地方，标出真正的疑点在哪里。",
    tag: "疑点清单",
    category: "反转",
    date: "08.22",
    readTime: "6 分钟",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20an%20hourglass%20and%20clock%20shapes%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=460&seq=lh-card-06&orientation=landscape",
  },
  {
    id: "ev7",
    title: "沉淀：热度退去后留下了什么",
    summary: "当讨论从情绪转向梳理，这一页汇总也就有了存在的必要。",
    tag: "阶段小结",
    category: "沉淀",
    date: "08.24 — 08.28",
    readTime: "4 分钟",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20an%20open%20archive%20box%20with%20sorted%20cards%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=460&seq=lh-card-07&orientation=landscape",
  },
  {
    id: "ev8",
    title: "对照：同一件事的五种说法",
    summary: "并排呈现几种流传最广的版本，一眼看出差异在哪。",
    tag: "版本对照",
    category: "沉淀",
    date: "08.26",
    readTime: "5 分钟",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20parallel%20columns%20and%20comparison%20lines%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=460&seq=lh-card-08&orientation=landscape",
  },
];

export const eventFilters = ["全部", "起底", "发酵", "回应", "反转", "沉淀"];

export const rankingList = [
  { id: "r1", rank: 1, title: "关键节点：公开回应全文对照", category: "回应", heat: "128.6万", trend: "up", change: "+32" },
  { id: "r2", rank: 2, title: "起底：最早那几条动态的时间顺序", category: "起底", heat: "96.2万", trend: "up", change: "+18" },
  { id: "r3", rank: 3, title: "转折点：早期线索重新浮现整理", category: "反转", heat: "81.4万", trend: "up", change: "+25" },
  { id: "r4", rank: 4, title: "二次传播路径与搬运号时间表", category: "发酵", heat: "64.9万", trend: "down", change: "-6" },
  { id: "r5", rank: 5, title: "合作方公开动作逐条罗列", category: "回应", heat: "52.3万", trend: "up", change: "+9" },
  { id: "r6", rank: 6, title: "并排呈现：同一件事的五种说法", category: "沉淀", heat: "44.1万", trend: "down", change: "-3" },
  { id: "r7", rank: 7, title: "还有哪几个细节没被说清楚", category: "疑点", heat: "37.8万", trend: "up", change: "+4" },
  { id: "r8", rank: 8, title: "一周之后：舆论场发生了什么变化", category: "复盘", heat: "29.5万", trend: "down", change: "-8" },
];

export const galleryItems = [
  {
    id: "g1",
    title: "灵灵黑料时间线总图 · 完整版",
    caption: "一张图看完全过程，适合收藏后慢慢对照。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20long%20horizontal%20timeline%20with%20connected%20dots%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=1200&height=900&seq=lh-gal-01&orientation=landscape",
  },
  {
    id: "g2",
    title: "关键节点速览卡",
    caption: "把八个月份压缩成一张卡片。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20stacked%20cards%20with%20numbered%20markers%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=520&seq=lh-gal-02&orientation=landscape",
  },
  {
    id: "g3",
    title: "说法对照长图",
    caption: "左右并排，差异一眼可见。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20split%20panels%20and%20contrast%20blocks%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=520&seq=lh-gal-03&orientation=landscape",
  },
  {
    id: "g4",
    title: "热度走势示意图",
    caption: "讨论量两次上扬分别发生在什么时候。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20rising%20curve%20chart%20with%20two%20peaks%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=520&seq=lh-gal-04&orientation=landscape",
  },
  {
    id: "g5",
    title: "文档归档封面",
    caption: "分阶段整理的封面设计。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20hardcover%20archive%20folder%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=520&seq=lh-gal-05&orientation=landscape",
  },
  {
    id: "g6",
    title: "复盘笔记版式",
    caption: "适合打印出来做笔记的一版。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20notebook%20lines%20and%20sticky%20note%20shapes%20in%20deep%20crimson%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20style%2C%20soft%20grain%2C%20clean%20simple%20background%2C%20magazine%20feature%20artwork&width=700&height=520&seq=lh-gal-06&orientation=landscape",
  },
];

export const faqItems = [
  {
    id: "f1",
    question: "灵灵黑料事件汇总到底包含哪些内容？",
    answer:
      "这一页按五个阶段整理了从起点到沉淀的完整经过，包含时间线、关键节点、外围动作与版本对照，目的就是让你不用在零散信息里来回翻找。",
  },
  {
    id: "f2",
    question: "为什么强调要看时间线，而不是直接看结论？",
    answer:
      "同一件事在不同时间点会呈现出完全不同的样子。按时间线走一遍，你能清楚看到每一步是怎么发生的，而不是只拿到一个被压缩过的结论。",
  },
  {
    id: "f3",
    question: "全盘点和大合集的更新频率是怎样的？",
    answer:
      "以阶段为单位补充，有新节点被确认时会追加到对应的阶段里，并在页面顶部更新时间标注，方便你判断内容的新鲜度。",
  },
  {
    id: "f4",
    question: "页面里的资料可以直接保存或分享吗？",
    answer:
      "可以。图文档案馆里的时间线长图与速览卡片都做了适合保存的版式，直接带走即可，收藏或分享都没有额外限制。",
  },
  {
    id: "f5",
    question: "如果不同地方的说法对不上，该以哪个为准？",
    answer:
      "建议以公开回应与原始素材作为参照，再对照各版本的差异。页面里的「版本对照」模块就是为此准备的，会并排呈现主要说法并标出分歧点。",
  },
  {
    id: "f6",
    question: "想第一时间知道有新节点补充，怎么办？",
    answer:
      "在页面下方的更新提醒里留下邮箱即可。有新内容补充时，你会收到一份整理好的摘要，点开就能看到最新节点。",
  },
];